module.exports = __webpack_public_path__ + "public/img/need_pay.27fdcf8c.png";